/**
 * Created by danielg on 3/2/15.
 */

define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};
    window.lpTag.WebAgent.publicModelController = window.lpTag.WebAgent.publicModelController || {};
    window.App = window.App || {};
    window.App.viewEventsHandler = window.App.viewEventsHandler || {};

    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpWebAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var PostMessageCourier = require("Chronos.PostMessageCourier");
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');

    var sdkCommunicationChannel = lpWebAgentStatics.COMMUNICATION_CHANNELS.SDK;

    var uniqueInstance;
    var iFrameMap = {};
    var defaultTimeoutDelay = 30000;
    var appNames = {
        manager: 'iFrame manager',
        events: 'iFrame events'
    };
    var logger = WebAgentLogger.getLogger('iFrame manager');

    var sdkCommands = {
        bind: 'bind',
        unbind: 'unbind',
        get: 'get',
        write: 'write',
        writeSC: 'writeSC',
        initialize: 'initialize',
        notify: 'notify',
        setConsumerProfile: 'setConsumerProfile',
        sendFile: 'sendFile',
        setChatNote: 'setChatNote'
    };

    function Singleton() {
        this.logger = logger;
    }

    /////////////////////////////////// PUBLIC METHODS ///////////////////////////////////
    Singleton.prototype.appNames = appNames;

    Singleton.prototype.cmdNames = {
        bind: 'Bind',
        unbind: 'Unbind',
        initialize: 'Initialize',
        write: 'Write ChatLine',
        writeSC: 'Write StructuredContent',
        sendFile: 'Send File',
        notify: 'Send Notification'
    };

    Singleton.prototype.eventNames = {
        notify: 'Notify',
        visitorFocused: 'Visitor Focused',
        visitorBlurred: 'Visitor Blurred'
    };

    Singleton.prototype.reqNames = {
        get: 'Get',
        setConsumerProfile: 'Set Consumer Profile',
        setChatNote: 'Set Chat Note'
    };

    /**
     * Adds an iFrame to the manager
     * @param iFrameView The iFrame object
     * @param domain The domain of the iFrame
     * @param visitorId The visitor ID
     * @param iFrameId The iFrame ID
     */
    Singleton.prototype.addIFrame = function (iframeObj) {
        this.logger.debug('adding iframe', 'addIFrame');
        var iframeContext, vid, id, domain, iFrameView, fallbackTime, permissions, displayName, chatId, applicationType;
        if (iframeObj) {
            iframeContext = iframeObj.context;
            if (iframeContext) {
                iFrameView = iframeContext.iframeView;
                vid = iframeContext.visitorId + '';
                id = iframeContext.id + '';
                domain = iframeObj.domain;
                fallbackTime = iframeObj.fallbackTime;
                permissions = iframeObj.permissions;
                displayName = iframeContext.displayName;
                chatId = iframeContext.chatId;
                applicationType = iframeContext.applicationType;
            }
        }
        if (vid && id && iFrameView && domain) {
            if ('undefined' === typeof iFrameMap[vid]) {
                iFrameMap[vid] = {
                    iFrames: {},
                    bindKeys: {}
                };
                _bindToUIEvents(vid);
            }
            if (iFrameMap[vid].iFrames[id]) {
                this.removeIFrame(vid, id);
            }
            var callback = iframeObj && iframeObj.callbacks && iframeObj.callbacks.setError;
            var channelAndTimeoutId = _createIFrameChannelAndSetTimeout.call(this, iFrameView, domain, iframeContext, callback, fallbackTime);
            var channel = channelAndTimeoutId.channel;

            iFrameMap[vid].iFrames[id] = {
                object: iFrameView,
                channel: channel,
                timeoutId: channelAndTimeoutId.timeoutId,
                callbacks: {
                    doneLoading: iframeObj && iframeObj.callbacks && iframeObj.callbacks.done
                },
                permissions: permissions
            };
            _complyToCommands({
                visitorId: vid,
                iFrameId: id,
                channel: channel,
                displayName: displayName,
                chatId: chatId,
                applicationType: applicationType
            });
        }
    };

    /**
     * Removes a visitor (and all the iFrames of the visitor) from the manager
     * @param visitorId The visitor ID
     */
    Singleton.prototype.removeVisitor = function (visitorId) {
        var vid = visitorId + '';
        if (vid && iFrameMap[vid]) {
            for (var iFrameId in iFrameMap[vid].iFrames) {
                if (iFrameMap[vid].iFrames.hasOwnProperty(iFrameId)) {
                    this.removeIFrame(visitorId, iFrameId);
                }
            }
            iFrameMap[vid] = null;
            delete iFrameMap[vid];
            _unbindFromUIEvents(vid);
        }
    };

    /**
     * Removes a single iFrame from the manager
     * @param visitorId The visitor ID
     * @param iFrameId The iFrame ID
     */
    Singleton.prototype.removeIFrame = function (visitorId, iFrameId) {
        var vid = visitorId + '';
        var id = iFrameId + '';
        if (vid && id && iFrameMap[vid] && iFrameMap[vid].iFrames[id]) {
            _unbindIFrame({ visitorId: vid, iFrameId: id });
            if (iFrameMap[visitorId].iFrames[iFrameId].channel) {
                if (iFrameMap[visitorId].iFrames[iFrameId].channel.dispose) {
                    iFrameMap[visitorId].iFrames[iFrameId].channel.dispose();
                }
                iFrameMap[visitorId].iFrames[iFrameId].channel = null;
                delete iFrameMap[visitorId].iFrames[iFrameId].channel;
            }
            iFrameMap[vid].iFrames[id] = null;
            delete iFrameMap[vid].iFrames[id];
        }
    };

    /**
     * Gets the iFrame object according to the visitor ID and iFrame ID
     * @param visitorId The visitor ID
     * @param iFrameId The iFrame ID
     * @returns The iFrame object
     */
    Singleton.prototype.getIFrameView = function (visitorId, iFrameId) {
        var vid = visitorId + '';
        var id = iFrameId + '';
        return iFrameMap && iFrameMap[vid] && iFrameMap[vid].iFrames && iFrameMap[vid].iFrames[id] && iFrameMap[vid].iFrames[id].object;
    };

    /**
     * Gets the lpEvents channel according to the visitor ID and iFrame ID
     * @param visitorId The visitor ID
     * @param iFrameId The iFrame ID
     * @returns The lpEvents channel
     */
    Singleton.prototype.getIFrameChannel = function (visitorId, iFrameId) {
        var vid = visitorId + '';
        var id = iFrameId + '';
        return iFrameMap && iFrameMap[vid] && iFrameMap[vid].iFrames && iFrameMap[vid].iFrames[id] && iFrameMap[vid].iFrames[id].channel;
    };

    /////////////////////////////////// PRIVATE METHODS ///////////////////////////////////

    /**
     * Creates an lpEvents channel to communicate with the iFrame
     * @param iFrameView The iFrame object
     * @param domain The domain of the iFrame
     * @returns {{channel: (PostMessageCourier|*), timeoutId: (*|number)}} The lpEvents channel
     * @private
     */
    function _createIFrameChannelAndSetTimeout(iFrameView, domain, iFrameContext, callback, fallbackTimeoutDelay) {
        var timeoutId, timeoutCallback, self = this;
        this.logger.info('creating channel and setting fallback URL timeout', '_createIFrameChannelAndSetTimeout');
        timeoutCallback = function () {
            self.logger.info('fallback timeout called');
            if (callback) {
                callback.call(iFrameContext);
            }
        };
        timeoutId = setTimeout(timeoutCallback, _getFallbackTimeoutDelay.call(this, fallbackTimeoutDelay));
        return {
            channel: new PostMessageCourier({ target: iFrameView, targetOrigin: domain }),
            timeoutId: timeoutId
        };
    }

    function _getFallbackTimeoutDelay(fallbackTimeoutDelay) {
        this.logger.info('getting fallback timeout delay', '_getFallbackTimeoutDelay');
        if (typeof fallbackTimeoutDelay === 'number' && !isNaN(fallbackTimeoutDelay) && fallbackTimeoutDelay > 0) {
            return fallbackTimeoutDelay;
        }
        return defaultTimeoutDelay;
    }

    /**
     * For a given iFrame, compiles to the commands for: bind; unbind; requestReply; write
     * @param data Contains the visitorId, iFrameId, channel
     * @private
     */
    function _complyToCommands(data) {
        var visitorId, iFrameId, channel, displayName, chatId, applicationType;
        if (data) {
            visitorId = data.visitorId;
            iFrameId = data.iFrameId;
            channel = data.channel;
            displayName = data.displayName;
            chatId = data.chatId;
            applicationType = data.applicationType;
        }
        if (channel && visitorId && iFrameId) {
            _complyToSingleCommand({visitorId: visitorId, iFrameId: iFrameId, channel: channel, command: sdkCommands.bind, callback: _bindToKey});
            _complyToSingleCommand({visitorId: visitorId, iFrameId: iFrameId, channel: channel, command: sdkCommands.unbind, callback: _unbindFromKey});
            _replyToSingleRequest({visitorId: visitorId, iFrameId: iFrameId, channel: channel, request: sdkCommands.get, callback: _replyToGetCallback});
            _replyToSingleRequest({visitorId: visitorId, iFrameId: iFrameId, channel: channel, request: sdkCommands.setConsumerProfile, callback: _setConsumerProfile });
            _replyToSingleRequest({visitorId: visitorId, iFrameId: iFrameId, channel: channel, request: sdkCommands.setChatNote, callback: _setChatNote });
            _complyToSingleCommand({visitorId: visitorId, iFrameId: iFrameId, channel: channel, command: sdkCommands.write, callback: _writeChatLine});
            _complyToSingleCommand({visitorId: visitorId, iFrameId: iFrameId, channel: channel, command: sdkCommands.writeSC, callback: _writeStructuredContent});
            _complyToSingleCommand({visitorId: visitorId, iFrameId: iFrameId, channel: channel, command: sdkCommands.sendFile, callback: _sendFile, chatId: chatId});
            _complyToSingleCommand({visitorId: visitorId, iFrameId: iFrameId, channel: channel, command: sdkCommands.initialize, callback: _stopTimeout});
            _complyToSingleCommand({visitorId: visitorId, iFrameId: iFrameId, channel: channel, displayName: displayName, chatId: chatId, applicationType: applicationType, command: sdkCommands.notify, callback: _sendNotification});
        }
    }

    function _stopTimeout(data) {
        var visitorId = data.context.visitorId;
        var iFramId = data.context.iFrameId;
        var timeoutId = iFrameMap[visitorId].iFrames[iFramId].timeoutId;
        clearTimeout(timeoutId);
        if (iFrameMap[visitorId].iFrames[iFramId].callbacks && iFrameMap[visitorId].iFrames[iFramId].callbacks.doneLoading) {
            iFrameMap[visitorId].iFrames[iFramId].callbacks.doneLoading.call();
        }
    }

    /**
     * Complies to a single command, and saves the callback (to stop complying later). If there is already a callback
     * we stop complying before starting to comply to the new callback.
     * @param data
     * @private
     */
    function _complyToSingleCommand(data) {
        var visitorId, iFrameId, channel, command, callback, displayName, chatId, applicationType;
        if (data) {
            visitorId = data.visitorId;
            iFrameId = data.iFrameId;
            channel = data.channel;
            command = data.command;
            callback = data.callback;
            displayName = data.displayName;
            chatId = data.chatId;
            applicationType = data.applicationType;
        }
        if (channel && visitorId && iFrameId && command && callback) {
            if (iFrameMap[visitorId].iFrames[iFrameId].callbacks[command]) {
                channel.stopComplying({
                    appName: Singleton.prototype.appNames.manager,
                    cmdName: Singleton.prototype.cmdNames[command],
                    func: iFrameMap[visitorId].iFrames[iFrameId].callbacks[command]
                });
            }
            if (!iFrameMap[visitorId].iFrames[iFrameId].permissions || !iFrameMap[visitorId].iFrames[iFrameId].permissions.command || iFrameMap[visitorId].iFrames[iFrameId].permissions.command[command] !== false) {
                iFrameMap[visitorId].iFrames[iFrameId].callbacks[command] = lpUtils.callbackContextWrapper(callback, {
                    visitorId: visitorId,
                    iFrameId: iFrameId,
                    displayName: displayName,
                    chatId: chatId,
                    applicationType: applicationType
                });
            } else {
                iFrameMap[visitorId].iFrames[iFrameId].callbacks[command] = lpUtils.callbackContextWrapper(_noPermissionCallback, {
                    visitorId: visitorId,
                    iFrameId: iFrameId,
                    displayName: displayName,
                    chatId: chatId,
                    applicationType: applicationType,
                    command: command
                });
            }
            channel.comply({
                appName: Singleton.prototype.appNames.manager,
                cmdName: Singleton.prototype.cmdNames[command],
                func: iFrameMap[visitorId].iFrames[iFrameId].callbacks[command]
            });
        }
    }

    /**
     * Replies to a single request, and saves the callback (to stop replying later). If there is already a callback
     * we stop replying before starting to reply to the new callback.
     * @param data
     * @private
     */
    function _replyToSingleRequest(data) {
        var visitorId, iFrameId, channel, request, callback;
        if (data) {
            visitorId = data.visitorId;
            iFrameId = data.iFrameId;
            channel = data.channel;
            request = data.request;
            callback = data.callback;
        }
        if (channel && visitorId && iFrameId && request && callback) {
            if (iFrameMap[visitorId].iFrames[iFrameId].callbacks[request]) {
                channel.stopReplying({
                    appName: Singleton.prototype.appNames.manager,
                    reqName: Singleton.prototype.reqNames[request],
                    func: iFrameMap[visitorId].iFrames[iFrameId].callbacks[request]
                });
            }
            iFrameMap[visitorId].iFrames[iFrameId].callbacks[request] = lpUtils.callbackContextWrapper(callback, {
                visitorId: visitorId,
                iFrameId: iFrameId
            });
            channel.reply({
                appName: Singleton.prototype.appNames.manager,
                reqName: Singleton.prototype.reqNames[request],
                func: iFrameMap[visitorId].iFrames[iFrameId].callbacks[request]
            });
        }
    }

    /**
     * Binds to UI events (focus/blur) according to the visitor ID
     * @param visitorId - The visitor ID to bind to
     * @private
     */
    function _bindToUIEvents(visitorId) {
        window.App.viewEventsHandler.bindEvent({
            appName: visitorId,
            UIEvent: window.App.viewEventsHandler.eventType.VISITOR_FOCUSED,
            callback: _changeFocus
        });
        window.App.viewEventsHandler.bindEvent({
            appName: visitorId,
            UIEvent: window.App.viewEventsHandler.eventType.VISITOR_BLURRED,
            callback: _changeFocus
        });
    }

    /**
     * Unbinds from UI events (focus/blur) according to the visitor ID
     * @param visitorId - The visitor ID to unbind from
     * @private
     */
    function _unbindFromUIEvents(visitorId) {
        window.App.viewEventsHandler.unbindEvent({
            appName: visitorId,
            UIEvent: window.App.viewEventsHandler.eventType.VISITOR_FOCUSED,
            callback: _changeFocus
        });
        window.App.viewEventsHandler.unbindEvent({
            appName: visitorId,
            UIEvent: window.App.viewEventsHandler.eventType.VISITOR_BLURRED,
            callback: _changeFocus
        });
    }

    /**
     * Changes focus for a single visitor. Triggers focus/blur events for each iFrame on the given visitor
     * @param data - The focus/blur event data
     * @private
     */
    function _changeFocus(data) {
        if (data && data.newValue) {
            var visitorId = data.newValue.appName + "";
            if (iFrameMap[visitorId] && iFrameMap[visitorId] && iFrameMap[visitorId].iFrames) {
                var eventName;
                if (data.newValue.UIEvent === window.App.viewEventsHandler.eventType.VISITOR_FOCUSED) {
                    eventName = 'visitorFocused';
                } else if (data.newValue.UIEvent === window.App.viewEventsHandler.eventType.VISITOR_BLURRED) {
                    eventName = 'visitorBlurred';
                }
                if (eventName && iFrameMap[visitorId].focusState !== eventName) {
                    for (var iFrameId in iFrameMap[visitorId].iFrames) {
                        if (iFrameMap[visitorId].iFrames.hasOwnProperty(iFrameId)) {
                            _triggerSingleEvent({ visitorId: visitorId, iFrameId: iFrameId, event: eventName });
                        }
                    }
                }
                iFrameMap[visitorId].focusState = eventName;
            }
        }
    }

    /**
     * Triggers a single event for an iFrame
     * @param data
     * @private
     */
    function _triggerSingleEvent(data) {
        var vid, id, channel, event, dataToSend;
        if (data) {
            vid = data.visitorId;
            id = data.iFrameId;
            event = data.event;
            dataToSend = data.data;
        }
        if (vid && id && iFrameMap[vid] && iFrameMap[vid].iFrames && iFrameMap[vid].iFrames[id]) {
            channel = iFrameMap[vid].iFrames[id].channel;
        }
        if (channel && event) {
            channel.trigger({
                appName: Singleton.prototype.appNames.events,
                eventName: Singleton.prototype.eventNames[event],
                data: dataToSend
            });
        }
    }

    /**
     * Unbinds all the bound keys for an iFrame, and stops complying to all the commands for an iFrame
     * @param data Contains the visitor ID and iFrame ID
     * @private
     */
    function _unbindIFrame(data) {
        var visitorId, iFrameId;
        if (data) {
            visitorId = data.visitorId;
            iFrameId = data.iFrameId;
        }
        if (visitorId && iFrameId && iFrameMap[visitorId] && iFrameMap[visitorId].iFrames[iFrameId]) {
            for (var key in iFrameMap[visitorId].bindKeys) {
                if (iFrameMap[visitorId].bindKeys.hasOwnProperty(key) && iFrameMap[visitorId].bindKeys[key].indexOf(iFrameId) >= 0) {
                    _unbindFromKey({ visitorId: visitorId, iFrameId: iFrameId, key: key });
                }
            }
            var channel = iFrameMap[visitorId].iFrames[iFrameId].channel;
            if (channel) {
                for (var command in iFrameMap[visitorId].iFrames[iFrameId].callbacks) {
                    if (iFrameMap[visitorId].iFrames[iFrameId].callbacks.hasOwnProperty(command)) {
                        if (Singleton.prototype.cmdNames.hasOwnProperty(command)) {
                            channel.stopComplying({
                                appName: Singleton.prototype.appNames.manager,
                                cmdName: Singleton.prototype.cmdNames[command],
                                func: iFrameMap[visitorId].iFrames[iFrameId].callbacks[command]
                            });
                        } else if (Singleton.prototype.reqNames.hasOwnProperty(command)) {
                            channel.stopReplying({
                                appName: Singleton.prototype.appNames.manager,
                                reqName: Singleton.prototype.reqNames[command],
                                func: iFrameMap[visitorId].iFrames[iFrameId].callbacks[command]
                            });
                        }
                        iFrameMap[visitorId].iFrames[iFrameId].callbacks[command] = null;
                        delete iFrameMap[visitorId].iFrames[iFrameId].callbacks[command];
                    }
                }
            }
        }
    }

    /**
     * Binds to a given key, for a given iFrame
     * @param data Contains the key to bind to, and a context object containing the visitor ID, and iFrame ID
     * @private
     */
    function _bindToKey(data) {
        var context, visitorId, iFrameId, key;
        if (data) {
            context = data.context;
            key = data.key;
        }
        if (context) {
            visitorId = context.visitorId;
            iFrameId = context.iFrameId;
        }
        if (key && visitorId && iFrameId) {
            _checkReadPermission(key, visitorId, iFrameId);
            // If this is the first time this visitor is binding to the key - we actually call bind to the model
            if (!iFrameMap[visitorId].bindKeys[key]) {
                iFrameMap[visitorId].bindKeys[key] = [];
                iFrameMap[visitorId].bindKeys[key].push(iFrameId);
                lpTag.WebAgent.publicModelController.bind(visitorId + '.' + key, _bindCallback);
            } else { // Send a Get command for this key and return the results to the channel
                var newValue = lpTag.WebAgent.publicModelController.get(visitorId + '.' + key);
                if (newValue) {
                    var getResults = {
                        key: key,
                        newValue: newValue
                    };
                    var channel = iFrameMap[visitorId].iFrames[iFrameId].channel;
                    if (channel) {
                        channel.trigger({
                            appName: Singleton.prototype.appNames.manager,
                            eventName: key,
                            data: getResults
                        });
                    }
                }
                // We add the iFrame ID to the array of ID that are bound to this key
                if (iFrameMap[visitorId].bindKeys[key].indexOf(iFrameId) < 0) {
                    iFrameMap[visitorId].bindKeys[key].push(iFrameId);
                }
            }

        }
    }

    /**
     * The callback which is triggered by a value change in the model. We forward the change by triggering the
     * channels of the bound iFrames
     * @param data
     * @private
     */
    function _bindCallback(data) {
        var visitorId, fullKey, key;
        if (data && data.key) {
            // fullKey = {visitorId}.{key}
            fullKey = data.key;
            var splitKeys = fullKey.split('.');
            if (splitKeys && splitKeys[0]) {
                visitorId = splitKeys[0];
            }
        }
        if (visitorId && iFrameMap[visitorId]) {
            key = fullKey.substring(visitorId.length + 1);
            // Since we're forwarding the data - we put the key that the iFrame requested
            var results = {
                key: key,
                newValue: data.newValue
            };
            if (key && iFrameMap[visitorId].bindKeys[key]) {
                // We trigger the data on the channel of each bound iFrame
                for (var index = 0; index < iFrameMap[visitorId].bindKeys[key].length; index++) {
                    var iFrameId = iFrameMap[visitorId].bindKeys[key][index];
                    var channel = iFrameMap[visitorId].iFrames[iFrameId].channel;
                    if (channel) {
                        channel.trigger({
                            appName: Singleton.prototype.appNames.manager,
                            eventName: key,
                            data: results
                        });
                    }
                }
            }
        }
    }

    /**
     * Unbinds from a given key, for a given iFrame
     * @param data Contains the visitor ID, iFrame ID (possibly in a context object) and key to unbind from
     * @private
     */
    function _unbindFromKey(data) {
        var context, visitorId, iFrameId, key;
        if (data) {
            context = data.context;
            key = data.key;
            // The visitor ID and iFrame ID can either be in the data (called directly) or in the context (called via callback)
            visitorId = (context && context.visitorId) || data.visitorId;
            iFrameId = (context && context.iFrameId) || data.iFrameId;
        }
        if (key && visitorId && iFrameId && iFrameMap[visitorId] && iFrameMap[visitorId].bindKeys[key] && iFrameMap[visitorId].bindKeys[key].indexOf(iFrameId) >= 0) {
            // Removing the iFrame ID from the list of bound iFrames
            var iFrameIndex = iFrameMap[visitorId].bindKeys[key].indexOf(iFrameId);
            iFrameMap[visitorId].bindKeys[key].splice(iFrameIndex, 1);
            // If the array of bound iFrame IDs is empty - we unbind from the model
            if (iFrameMap[visitorId].bindKeys[key].length === 0) {
                lpTag.WebAgent.publicModelController.unbind(visitorId + '.' + key, _bindCallback);
                iFrameMap[visitorId].bindKeys[key] = null;
                delete iFrameMap[visitorId].bindKeys[key];
            }
        }
    }

    /**
     * Returns data from the model according to the visitor ID and model key.
     * @param data Contains the visitor ID (within our context) and the key to get.
     * @private
     */
    function _replyToGetCallback(data) {
        var context, visitorId, iFrameId, key;
        if (data) {
            context = data.context;
            key = data.key;
        }
        if (context) {
            visitorId = context.visitorId;
            iFrameId = context.iFrameId;
        }
        _checkReadPermission(key, visitorId, iFrameId);
        return lpTag.WebAgent.publicModelController.get(visitorId + '.' + key);
    }

    /**
     * Checks if the iFrame has permission to view the requested key
     * @param key The key the iFrame wants to get/bind
     * @param visitorId The visitor ID
     * @param iFrameId The iFrame ID
     * @private
     */
    function _checkReadPermission(key, visitorId, iFrameId) {
        if (iFrameMap[visitorId] && iFrameMap[visitorId].iFrames && iFrameMap[visitorId].iFrames[iFrameId] && iFrameMap[visitorId].iFrames[iFrameId].permissions && iFrameMap[visitorId].iFrames[iFrameId].permissions.read) {
            for (var rootPath in iFrameMap[visitorId].iFrames[iFrameId].permissions.read) {
                if (key.indexOf(rootPath) === 0 && iFrameMap[visitorId].iFrames[iFrameId].permissions.read[rootPath] === false) {
                    throw new Error('You do not have permission to view this data. Ask your administrator to add permission to view ' + rootPath);
                }
            }
        }
    }

    /**
     * Handler for SDK set consumer profile
     * @param {Object} data an object containd context and json
     */
    function _setConsumerProfile(data, callback) {
        if (!data) {
            throw new Error('Invalid data');
        }

        var consumerId = data.context && data.context.visitorId;
        var chatId = lpTag.WebAgent.logicController.getChatIdFromVisitorId(consumerId);
        if (!lpTag.WebAgent.logicController.hasPermissionToSetConsumerProfile(chatId, consumerId)) {
            throw new Error('You have no permission to set the consumer profile');
        }

        if (!lpTag.WebAgent.publicModelController.get(consumerId + ".chatInfo.isMessaging")) {
            throw new Error('Cannot set consumer profile for chat conversations');
        }

        // support SDK setConsumerProfile command
        if (data && data.json) {
            data = data.json;
        }

        if (!consumerId || !data || !Object.keys(data).length) {
            throw new Error('Cannot set consumer profile without data');
        }

        // apply existing data, userId and callbacks to the sent json object
        logger.info('Sending consumer profile update request', '_setConsumerProfile');
        var payload = lpUtils.cloneObject(data);
        payload.userId = consumerId;
        payload.success = onSetConsumerSuccess;
        payload.error = onSetConsumerError;
        lpTag.WebAgent.amsUserProfilesController.setConsumerProfileOnBehalfOfAgent(payload);

        function onSetConsumerSuccess() {
            if(callback && typeof callback === "function") {
                callback();
            }
            var payload = {
                userId: consumerId,
                success: onGetProfileSuccess
             };
            // call the updated consumer profile
            lpTag.WebAgent.amsUserProfilesController.getUserProfile(payload, true);

            function onGetProfileSuccess(params) {
                window.lpTag.WebAgent.channel.publish(sdkCommunicationChannel.name, sdkCommunicationChannel.events.onUserProfileSetCompleted, { consumerId: consumerId });
            }
        }

        function onSetConsumerError(err) {
            // we intentionally mask the errors from the server
            if (callback && typeof callback === "function") {
                callback({ error: 'Unexpected error' });
            }
        }
    }

    /**
     * Handler for SDK set chat note (agent summery)
     * @param {Object} data an object containd context and json - {agentNote: 'test'}
     */
    function _setChatNote(data, callback) {
        if (!data) {
            throw new Error('Invalid data');
        }

        var consumerId = data.context && data.context.visitorId;
        var chatId = lpTag.WebAgent.logicController.getChatIdFromVisitorId(consumerId);

        if (!lpTag.WebAgent.publicModelController.get(consumerId + ".chatInfo.isMessaging")) {
            throw new Error('Set chat note supported in Async Messaging Conversation only.');
        }
        
        if (!lpTag.WebAgent.logicController.isMyChat(chatId)) {
            throw new Error('Set Chat Note is allowed‎ only to the assigned agent.');
        }
        
        if (!consumerId || !data || data.agentNote == undefined) {
            throw new Error('Cannot set Chat note without data');
        }

        // apply existing data, userId and callbacks to the sent json object
        logger.info('Sending chat note', '_setChatNote');
        var payload = lpUtils.cloneObject(data);
        payload.conversationId = chatId;
        payload.success = onSetNoteSuccess;
        payload.error = onSetNoteError;
        lpTag.WebAgent.amsConversationController.setAgentNote(payload);

        function onSetNoteSuccess() {
            if(callback && typeof callback === "function") {
                callback();
            }
        }

        function onSetNoteError(err) {
            // we intentionally mask the errors from the server
            if (callback && typeof callback === "function") {
                callback({ error: 'Unexpected error' });
            }
        }
    }

    /**
     * Sends text to the chat input - via viewEvents
     * @param data Contains the text to send, and a context object containing the visitor ID and iFrame ID
     * @param doneCallback Callback for when the write command is done (optional errors)
     * @private
     */
    function _writeChatLine(data, doneCallback) {
        var context, visitorId, text, quickReplies, _doneCallback = doneCallback || $.noop;

        if (data) {
            context = data.context;
            text = data.text;
            quickReplies = _.isEmpty(data.quickReplies) ? void 0 : data.quickReplies;
        }
        if (context) {
            visitorId = context.visitorId;
        }
        if (text && visitorId) {
            window.App.viewEventsHandler.fireEvent({
                appName: visitorId,
                UIEvent: window.App.viewEventsHandler.eventType.WIDGET_CONTENT_SEND,
                eventData: {text: text, quickReplies: quickReplies, doneCallback: _doneCallback},
                deleteOnFire: true
            });
        } else if (!text) {
            _doneCallback('Chat line not sent. Reason: no text provided.');
        }
    }

    /**
     * Handler for SDK structured content
     * @param {Object} data a json object, must be complient with the sctructured content spec
     * @param {Function} doneCallback Callback for when the write command is done (optional errors)
     */
    function _writeStructuredContent(data, doneCallback) {
        var context,
            visitorId,
            json,
            quickReplies,
            metadata,
            _doneCallback = doneCallback || $.noop;

        if (data) {
            context = data.context;
            json = data.json;
            quickReplies = _.isEmpty(data.quickReplies) ? void 0 : data.quickReplies;
            metadata = data.metadata;
        }
        if (context) {
            visitorId = context.visitorId;
        }
        if (!lpTag.WebAgent.logicController.isRichContentEnabled()) {
            _doneCallback('RichContent feature is not enabled for this account');
        } else {
            if (json && visitorId) {
                window.App.viewEventsHandler.fireEvent({
                    appName: visitorId,
                    UIEvent: window.App.viewEventsHandler.eventType.WIDGET_CONTENT_SEND,
                    eventData: {json: json, quickReplies: quickReplies, metadata: metadata, doneCallback: _doneCallback},
                    deleteOnFire: true
                });
            } else if (!json) {
                _doneCallback('Structure Content not sent. Reason: no input provided.');
            }
        }
    }

    /**
     * Handler for SDK send file
     * @param {Object} data containing a file (must be a File or Blob) and the visitor ID and chat ID
     * @param {Function} doneCallback Callback for when the send file command is done (optional errors)
     */
    function _sendFile(data, doneCallback) {
        var context,
            visitorId,
            chatId,
            file;

        if (data) {
            context = data.context;
            file = data.file || {};
            file.name = data.name || file.name;
        }
        if (context) {
            visitorId = context.visitorId;
            chatId = context.chatId;
        }
        if (!lpTag.WebAgent.logicController.canConsumerReceiveFileFromCustomWidget(chatId)) {
            if (doneCallback) {
                if (!lpTag.WebAgent.logicController.isEngagementAsyncMessaging(chatId)) {
                    doneCallback('File not sent. Reason: cannot send file in chat, only in async messaging.');
                } else if (lpTag.WebAgent.logicController.getChatStateByChatId(chatId, 'chats') !== lpTag.WebAgent.logicController.chatStates.chatting) {
                    doneCallback('File not sent. Reason: cannot send file in closed conversation, only in open conversation');
                } else if (!lpTag.WebAgent.logicController.isAgentFileSharingEnabled()) {
                    doneCallback('File not sent. Reason: agent file sharing is disabled. Make sure that the site setting \'messaging.agent.file.sharing.enabled\' is \'true\'.');
                } else if (!privilegesController.hasSendFilesFromCustomWidgetPrivilege()) {
                    doneCallback('File not sent. Reason: no permission to execute this command');
                } else {
                    doneCallback('File not sent. Reason: consumer cannot receive file');
                }
            }
        } else {
            if (data && data.file && file.name && visitorId) {
                lpTag.WebAgent.AppMediator.onFileSelected({file: file, visitorId: visitorId, chatId: chatId, callback: doneCallback});
            } else if (visitorId && doneCallback && data && data.file) {
                doneCallback('File not sent. Reason: no name provided.');
            } else if (visitorId && doneCallback) {
                doneCallback('File not sent. Reason: no file provided.');
            }
        }
    }

    /**
     * Sends notification to the ui - via viewEvents
     * @param data Contains a context object containing the visitor ID, iFrame ID, chat Id, and the widget name (displayName)
     * @param doneCallback Callback for when the send notification command is done (optional errors)
     * @private
     */
    function _sendNotification(data, doneCallback) {
        var chatState;
        if (data && data.context) {
            chatState = lpTag.WebAgent.publicModelController.get(data.context.visitorId + '.visitorInfo.chattingVisitorState');
        }
        if (chatState && chatState === 'chatting') {
            lpTag.WebAgent.channel.publish(
                lpWebAgentStatics.COMMUNICATION_CHANNELS.AppEvents.name,
                lpWebAgentStatics.COMMUNICATION_CHANNELS.AppEvents.events.sdkNotification,
                {
                    visitorId: data.context.visitorId,
                    iFrameId: data.context.iFrameId,
                    displayName: data.context.displayName,
                    chatId: data.context.chatId,
                    applicationType: data.context.applicationType
                }
            );
            if (doneCallback) {
                doneCallback();
            }
        } else if (doneCallback) {
            doneCallback('notification not sent. Reason: the chat has already ended.');
        }
    }

    function _noPermissionCallback(data, doneCallback) {
        var context, command, cmdName, message;
        if (data) {
            context = data.context;
        }
        if (context) {
            command = context.command;
        }
        if (command) {
            cmdName = Singleton.prototype.cmdNames[command];
        }
        message = 'Not sent. Reason: no permission to execute this command';
        if (command) {
            var replacement = '"' + command + '"';
            if (cmdName) {
                replacement += ' ("' + cmdName + '")';
            }
            message.replace('this', replacement);
        }
        if (doneCallback) {
            doneCallback(message);
        }
        return;
    }

    lpTag.lpIframeManager = {
        getInstance: function () {
            if (!uniqueInstance) {
                uniqueInstance = new Singleton();
            }
            return uniqueInstance;
        }
    };

    return lpTag.lpIframeManager;

});
